import React, { useEffect, useState } from 'react';

import { CharacterSheetInterface, WEAPON_KEYWORDS, WeaponKeyword } from "@dndModels";

import FlexBox from '@components/layout/FlexBox';
import CommonUtilities from '@utilities/common_utilities';
import SelectStringBox from '@components/input/selects/SelectStringBox';

interface Props {
  char: CharacterSheetInterface;
}

const common_util = CommonUtilities.getInstance();

export default function CharacterWeaponProfCustomizations({
  char,
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);

  const customizations = char.customizations;

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const renderWeaponProfCustomization = (weapon_keyword: WeaponKeyword) => {
    // debugger;
    const proficient = char.mind.weapon_proficiencies.find(o => o.proficiency_id === weapon_keyword._id);
    return (
      <FlexBox key={weapon_keyword._id}>
        <FlexBox direction="row">
          <FlexBox xs_expand={0} style={{ width: "30%"}}>
            <FlexBox direction="column">
              <FlexBox>{ weapon_keyword.name }</FlexBox>
              { proficient && 
                <FlexBox className="small_label gray">Proficient</FlexBox>
              }
              { customizations.weapon_prof_overrides[weapon_keyword._id] !== undefined &&
                <FlexBox className="small_label gray">Overridden</FlexBox>
              }
            </FlexBox>
          </FlexBox>
          <FlexBox>
            <SelectStringBox 
              name="Override"
              value={ customizations.weapon_prof_overrides[weapon_keyword._id] === undefined ? "Don't Override" : (customizations.weapon_prof_overrides[weapon_keyword._id] ? "true" : "false") } 
              options={[{ id: "true", text: "Proficient" }, { id: "false", text: "Not Proficient" }]}
              extra_options={["Don't Override"]}
              onChange={ async (changed: string) => {
                if (changed === "Don't Override") {
                  delete customizations.weapon_prof_overrides[weapon_keyword._id];
                } else {
                  customizations.weapon_prof_overrides[weapon_keyword._id] = changed === "true";
                }
                setPing(!ping);
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        </FlexBox>
      </FlexBox>
    );
  }

  return (
    <FlexBox direction="column" style={{ width: "100%" }}>
      { WEAPON_KEYWORDS.filter(o => o.name.includes("Martial") || o.name.includes("Simple")).sort((a, b) => {
        return a.name.localeCompare(b.name);
      }).map(weapon_keyword => renderWeaponProfCustomization(weapon_keyword))}
    </FlexBox>
  );
}

